import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { DomainSheet } from "@/components/domain";

export const Route = createFileRoute(
  "/(payment-adjustments)/payment-adjustments/$id/_sheet",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <DomainSheet
      onClose={() => navigate({ to: `/payment-adjustments/${id}` })}
    />
  );
}
